







































import Vue from '@front-app/vendor/vue';
import {
	computed,
	defineComponent,
	nextTick,
	PropType,
	ref,
	Ref,
} from '@vue/composition-api';
import Fuse from 'fuse.js';
import { Size } from '@front-app/components/constants';
import { UserAvatarStore } from '@front-app/store/singletons/User';
import { FullUser } from '@front-app/services/UserApi/UserModel';
import { useUsername } from '@front-app/hooks/useTranslate';
import { ColleaguesStore } from '@front-app/store/singletons/Colleagues';
import SearchBox from '../search/SearchBox.vue';
import SearchPlaceholder from '../search/SearchPlaceholder.vue';
import SearchResult from '../search/SearchResult.vue';
import { useRollingIndex } from '../search/useRollingIndex';

const FUSE_OPTIONS = {
	keys: ['firstName', 'lastName', 'middleName'],
};

const COLLEAGUE_RESULT_LIMIT = 50;

export default defineComponent({
	components: {
		SearchBox,
		SearchPlaceholder,
		SearchResult,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
		excludedUsers: {
			type: Array as PropType<string[]>,
			default: () => [],
		},
		resultSize: {
			type: String as PropType<Size>,
			default: Size.MEDIUM,
		},
		hasError: Boolean,
	},
	setup(props, ctx) {
		const getUsername = useUsername(ctx);
		const userSearchString = ref('');
		const { colleagues } = ColleaguesStore;

		const userSearchResults = computed(() => {
			const searchableColleagues = colleagues.value.filter(({ id }) => !props.excludedUsers.includes(id));
			if (userSearchString.value.trim() === '') {
				return searchableColleagues;
			}
			const fuse = new Fuse(searchableColleagues, FUSE_OPTIONS);
			return fuse.search(userSearchString.value, { limit: COLLEAGUE_RESULT_LIMIT })
				.map(({ item }) => item);
		});
		const el: Ref<null | Vue> = ref(null);
		const handleSearchItemClicked = async (user: FullUser): Promise<void> => {
			userSearchString.value = '';
			ctx.emit('select', user);
			const elVal = el.value;
			if (!elVal) {
				return;
			}
			await nextTick();
			elVal.$el.querySelector('input')?.focus();
		};
		const searchFocus = useRollingIndex(userSearchResults);
		const focusedSearchIdx = searchFocus.selectedIdx;
		const focusNextSearchResult = searchFocus.next;
		const focusPrevSearchResult = searchFocus.prev;
		const openFirstSearchResult = async () => {
			if (userSearchResults.value.length === 0) {
				return;
			}
			await handleSearchItemClicked(userSearchResults.value[0]);
		};
		const handleUserSearchInput = async (name: string) => {
			focusedSearchIdx.value = null;
			userSearchString.value = name;
		};
		return {
			el,
			handleSearchItemClicked,
			userSearchResults,
			userSearchString,
			handleUserSearchInput,
			focusedSearchIdx,
			focusNextSearchResult,
			focusPrevSearchResult,
			openFirstSearchResult,
			// Avatar
			getAvatar: UserAvatarStore.get,
			fetchAvatar: UserAvatarStore.fetch,
			// Util
			getUsername,
		};
	},
});
